import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { mobileMenuContext } from "../contexts/MobileMenuProvider";
import MobileMenuItem from "./MobileMenuItem";
import PermissionGate from "./PermissionGate";

const MobileMenu = () => {
  const { setOpenMenu } = useContext(mobileMenuContext);
  const location = useLocation();
  const { pathname } = location;

  return (
    <div className="app-sidebar flex-column drawer drawer-start drawer-on w-100 vh-100">
      {/*begin::Header*/}
      <div className="app-sidebar-header d-flex flex-column px-5 sticky-top bg-primary">
        {/*begin::Brand*/}
        <div className="d-flex flex-stack">
          {/*begin::User*/}
          <div className="">
            {/*begin::User info*/}
            <div className="d-flex align-items-start">
              <Link to="/">
                <img
                  alt="Logo"
                  src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/logos/logo-light.png`}
                  style={{ width: "60px" }}
                />
              </Link>
            </div>
            {/*end::User info*/}
          </div>
          {/*end::User*/}
          {/*begin::Close Button*/}
          <button
            onClick={() => setOpenMenu((prev) => !prev)}
            className="btn btn-custom btn-icon"
          >
            <i
              className="ki-duotone ki-cross-square text-light rounded"
              style={{ fontSize: "30px" }}
            >
              <span className="path1"></span>
              <span className="path2"></span>
            </i>
          </button>
          {/*begin::Menu 1*/}
          {/*end::Menu 1*/} {/*end::Close Button*/}
        </div>
        {/*end::Brand*/}
      </div>
      {/*end::Header*/}
      {/*begin::Navs*/}
      <div
        className="app-sidebar-navs flex-column-fluid"
        id="kt_app_sidebar_navs"
      >
        <ul className="list-group">
          <MobileMenuItem
            icon={``}
            text={`Overview`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-geolocation text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            }
            text={`Driver Map`}
            link={`/dashboard`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-ship text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            }
            text={`Ongoing Orders`}
            link={`/dashboard/ongoing-orders`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={``}
            text={`Merchants`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-profile-circle text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            }
            text={`All Merchants`}
            link={`/merchants/all-merchants`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-plus-circle text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            }
            text={`Create New`}
            link={`/merchants/create-merchant`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <PermissionGate
            required={`view_merchant_signups`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-user-tick text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              }
              text={`Signups`}
              link={`/merchants/signups`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-profile-user text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </i>
            }
            text={`Groups`}
            link={`/merchants/groups`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-document text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            }
            text={`Pricing Sheet`}
            link={`/merchants/pricing-sheet`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-cheque text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
                <span className="path6"></span>
                <span className="path7"></span>
              </i>
            }
            text={`All Transactions`}
            link={`/merchants/all-transactions`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <PermissionGate
            required={`view_all_merchants_consumption_list`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-notification-status text-gray-700 fs-1 me-2">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </i>
              }
              text={`Consumption`}
              link={`/merchants/consumption`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-notification-status text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </i>
            }
            text={`Notifications`}
            link={`/merchants/all-notifications`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <PermissionGate
            required={`view_low_balance_alert_setting`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-dollar text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </i>
              }
              text={`Low Balance Alert`}
              link={`/merchants/low-balance-alert`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <MobileMenuItem
            icon={``}
            text={`Drivers`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-delivery text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
              </i>
            }
            text={`All Drivers`}
            link={`/drivers/all-drivers`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-car text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
              </i>
            }
            text={`Create New`}
            link={`/drivers/create-driver`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={``}
            text={`Orders`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-cube-3 text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            }
            text={`All Orders`}
            link={`/orders/all-orders`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={``}
            text={`Delivery Companies`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-logistic text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
                <span className="path6"></span>
                <span className="path7"></span>
              </i>
            }
            text={`All Companies`}
            link={`/delivary-companies/all-delivary-companies`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-delivery-door text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </i>
            }
            text={`Create New`}
            link={`/delivary-companies/create-delivary-company`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={``}
            text={`Archive`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-user-square text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            }
            text={`Merchants`}
            link={`/archive/merchants`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-delivery-time text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
              </i>
            }
            text={`Drivers`}
            link={`/archive/drivers`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-courier text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            }
            text={`Employees`}
            link={`/archive/employees`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-delivery-2 text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
                <span className="path6"></span>
                <span className="path7"></span>
                <span className="path8"></span>
                <span className="path9"></span>
              </i>
            }
            text={`Delivary Companies`}
            link={`/archive/delivary-companies`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={``}
            text={`Settings`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-shield text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            }
            text={`Configure Roles`}
            link={`/settings/configure-roles`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-user-tick text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            }
            text={`User Role`}
            link={`/settings/user-role`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <PermissionGate
            required={`view_driver_pricing_model_list`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-discount text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              }
              text={`Driver Payout`}
              link={`/settings/driver-sharing`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <PermissionGate
            required={`view_driver_pricing_model_list`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-file-added text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              }
              text={`Order Scan Limit`}
              link={`/settings/order-scan-limit`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-dollar text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            }
            text={`Pricing Model`}
            link={`/settings/pricing-model`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <PermissionGate
            required={`view_driver_pricing_model_list`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-scooter text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                </i>
              }
              text={`Driver Pricing Model`}
              link={`/settings/driver-pricing-model`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <PermissionGate
            required={`view_company_pricing_model_list`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-scooter text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                </i>
              }
              text={`Company Commission Model`}
              link={`/settings/company-pricing-model`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-chart-pie-3 text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            }
            text={`Revenue Stat`}
            link={`/settings/revenue-stat`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={``}
            text={`Reports`}
            link={``}
            type={`menu`}
            setOpenMenu={setOpenMenu}
          />
          <MobileMenuItem
            icon={
              <i className="ki-duotone ki-badge text-gray-700 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
              </i>
            }
            text={`Driver Report`}
            link={`/reports/driver-report`}
            type={`sub-menu`}
            setOpenMenu={setOpenMenu}
          />
          <PermissionGate
            required={`view_manual_action_report`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-document text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              }
              text={`Manual Action Report`}
              link={`/reports/manual-action-report`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <PermissionGate
            required={`view_driver_busy_report`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-document text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              }
              text={`Driver Busy Report`}
              link={`/reports/driver-busy-report`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
          <PermissionGate
            required={`view_integration`}
            fallback={<></>}
            show={false}
          >
            <MobileMenuItem
              icon={``}
              text={`Integrations`}
              link={``}
              type={`menu`}
              setOpenMenu={setOpenMenu}
            />
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-abstract-26 text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              }
              text={`Ordable`}
              link={`/integrations/ordable`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
            <MobileMenuItem
              icon={
                <i className="ki-duotone ki-wallet text-gray-700 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              }
              text={`Payment Gateway`}
              link={`/integrations/payment-gateway`}
              type={`sub-menu`}
              setOpenMenu={setOpenMenu}
            />
          </PermissionGate>
        </ul>
      </div>
      {/*end::Navs*/}
    </div>
  );
};

export default MobileMenu;